// components
import VendorBottomNavigation from "../../kits/bottomNavigation/VendorBottomNav/VendorBottomNavigation.jsx";

// react & hooks
import useWindowSize from "../../../hooks/useWindowSize.jsx";

export default function VendorLayout(props) {
  const { width, height } = useWindowSize();

  return (
    <div className="bg-vendor-layout">
      <div className="layout-container mr-x-auto" id="root-container">
        <div id="drawer-container" />

        <div
          className={`scroll `}
          style={{ height: props.bottomNav ? `${height - 73}px` : "100vh" }}
        >
          {props.children}
        </div>
        {props.bottomNav && <VendorBottomNavigation />}
      </div>
    </div>
  );
}
